





























































import {Component, Vue} from 'vue-property-decorator';
import {PutCouponsIssuesCouponIssueNoWithdrawRequest} from 'supporter';
import {popupResize} from '@/utils/ncp';

@Component
export default class WithdrawCoupon extends Vue {
  private withdrawReason = '';
  private withdrawYmdt = '';
  private withdrawAdminName = '';
  private couponIssueNo = '';
  private type = true;
  private reason = '';
  private putWithdrawRequest: PutCouponsIssuesCouponIssueNoWithdrawRequest = {
    pathParams: {
      couponIssueNo: ''
    },
    data: {
      reason: ''
    }
  };
  private created() {
    if (localStorage.getItem('CouponsIssueArray')) {
      let CouponsIssueArray = JSON.parse(localStorage.getItem('CouponsIssueArray'));
      if (CouponsIssueArray.couponUseStatusType === 'USABLE') {
        this.type = true;
      } else {
        this.type = false;
        this.withdrawReason = CouponsIssueArray.withdrawReason;
        this.withdrawYmdt = CouponsIssueArray.withdrawYmdt;
        this.withdrawAdminName = CouponsIssueArray.withdrawAdminName;
      }
    }
  }
  private mounted() {
    this.couponIssueNo = this.$route.query.couponIssueNo as string;
  }
  private destroyed() {
    localStorage.removeItem('CouponsIssueArray');
    localStorage.removeItem('couponsIssueRequest');
  }
  private confirmBtn() {
    // 철회 화면
    if (this.type) {
      if (this.reason === '') {
        window.close();
      } else {
        this.putWithdrawRequest.pathParams.couponIssueNo = this.couponIssueNo;
        this.putWithdrawRequest.data.reason = this.reason;
        this.$api.putCouponsIssuesCouponIssueNoWithdraw(this.putWithdrawRequest).then((): void => {
          alert(window.$t('MEMBER_CRM_WITHDRAW_OVER'));
          let couponsIssueRequest = JSON.parse(localStorage.getItem('couponsIssueRequest'));
          this.$api.getCouponsIssue(couponsIssueRequest).then((result): void => {
            this.type = false;
            popupResize(810, 315);
            result.data.contents.forEach(e => {
              if (e.couponIssueNo === Number(this.couponIssueNo)) {
                this.withdrawReason = e.withdrawReason;
                this.withdrawYmdt = e.withdrawYmdt;
                this.withdrawAdminName = e.withdrawAdminName;
              }
            });
          });
          if (this.$route.query && this.$route.query.callback) {
            $(window.opener.location).attr('href', `javascript:window.${this.$route.query.callback}();`);
          }
        });
      }
      // 상세보기 화면
    } else {
      window.close();
    }
  }
  private cancelBtn() {
    window.close();
  }
  private countChange() {
    if (this.reason.length === 0) {
      return '';
    } else if (this.reason.length === 20) {
      return ' max';
    } else {
      return ' counting';
    }
  }
}
